import { useAppSelector } from '../../core'
import { selectIsOutOfCredits } from '../slices'
import { useCreditsExhaustedTopUp } from '../hooks/useCreditsExhaustedTopUp'
import { CreditsExhaustedNotice } from './CreditsExhaustedNotice'

/**
 * Full-width out-of-credits banner pinned to the top of the app (mirrors
 * PendingInvitationsBanner's placement/structure). Renders nothing while the
 * user has credits — it only appears when fully out (0). Persistent by design:
 * out-of-credits is a hard block, so there's no dismiss — the only way out is
 * the Add credits button, which opens the TopUpModal.
 */
function CreditExhaustedBannerActive() {
  const handleTopUp = useCreditsExhaustedTopUp({ modalSource: 'top_banner' })
  return <CreditsExhaustedNotice variant="banner" onTopUp={handleTopUp} />
}

export function CreditExhaustedBanner() {
  const isOutOfCredits = useAppSelector(selectIsOutOfCredits)
  if (!isOutOfCredits) return null
  return <CreditExhaustedBannerActive />
}
